export const useStyles = () => {
  return {
    root: {
      position: 'relative',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow:
        '0px 1px 2px rgba(16, 24, 40, 0.06), 0px 1px 3px rgba(16, 24, 40, 0.10)',
      backgroundColor: '#000',
      '@media (max-width: 900px)': {
        width: '240px',
        height: '320px',
        flex: '0 0 auto',
        scrollSnapAlign: 'center',
      },
    },
    image: (imageUrl: string) => ({
      position: 'absolute' as const,
      inset: 0,
      backgroundImage: `url(${imageUrl})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    }),
    footer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      height: '82px',
      padding: '16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      flexShrink: 0,
      alignSelf: 'stretch',
      background: 'rgba(0, 0, 0, 0.40)',
      backdropFilter: 'blur(12px)',
      '@media (max-width: 900px)': {
        height: '64px',
        padding: '12px',
      },
    },
    title: {
      color: '#FFFFFF',
      textAlign: 'center',
      fontFamily: 'Noto Sans',
      fontSize: '18px',
      fontWeight: 600,
      '@media (max-width: 900px)': {
        fontSize: '16px',
      },
    },
  } as const;
};

